import type { StepT } from "@/components/common/Stepper";

export const onboardingRoutes = {
    name: "/onboarding/name",
    dateOfBirth: "/onboarding/date-of-birth",
    email: "/onboarding/email",
    phone: "/onboarding/phone",
    notifications: "/onboarding/notifications",
    clinicianNumber: "/onboarding/clinician-number",
    professionalDetails: "/onboarding/clinician/professional",
    profile: "/profile",
} as const;

export const patientSteps: Omit<StepT, "stage">[] = [
    { words: "Name", route: { to: onboardingRoutes.name } },
    { words: "Date of Birth", route: { to: onboardingRoutes.dateOfBirth } },
    { words: "Email", route: { to: onboardingRoutes.email } },
    { words: "Phone", route: { to: onboardingRoutes.phone } },
    { words: "Notifications", route: { to: onboardingRoutes.notifications } },
];

export const clinicianSteps: Omit<StepT, "stage">[] = [
    { words: "Name & Organization", route: { to: onboardingRoutes.name } },
    {
        words: "Professional Details",
        route: { to: onboardingRoutes.professionalDetails },
    },
];

export const secretarySteps: Omit<StepT, "stage">[] = [
    { words: "Name", route: { to: onboardingRoutes.name } },
    { words: "Notifications", route: { to: onboardingRoutes.notifications } },
];
